import { faCheckSquare } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ChangeEvent, ReactElement } from "react";
import { Button, FormControl, ProgressBar } from "react-bootstrap";
import Swal, { SweetAlertResult } from "sweetalert2";
import { ProjectTaskChecklist } from ".";
import { Editable } from "../ui";
import { useProjects } from "./ProjectContext";
import { ProjectTask } from "./ProjectTask";
import { ProjectTaskChecklistItem } from "./ProjectTaskChecklistItem";
import { ProjectTaskChecklistItemElement } from "./ProjectTaskChecklistItemElement";

interface IProps {
	checklist: ProjectTaskChecklist;
	task: ProjectTask;
}

export const ProjectTaskChecklistElement = (props: IProps): ReactElement => {
	const { task } = props;
	const projectContext = useProjects();

	const checklist = props.checklist;

	const handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		Swal.fire({
			title: "Are you sure?",
			text: "All checklist items will be deleted",
			icon: "warning",
			confirmButtonText: "Yes, delete it!",
			showCancelButton: true,
		}).then((result: SweetAlertResult) => {
			if (result.value) {
				projectContext.deleteProjectTaskChecklist!(task, checklist);
			}
		});
	};

	const handleAddItem = () => {
		const newItem = new ProjectTaskChecklistItem();
		newItem.title = "Checklist item";

		projectContext.saveAddProjectTaskChecklistItem!(
			task,
			checklist,
			newItem,
		);
	};

	const editableName = (
		<Editable
			shownComponent={
				<>
					<FontAwesomeIcon
						className="task-icon"
						icon={faCheckSquare}
						size="lg"
						fixedWidth
					/>
					<h3 style={{ marginBottom: 10 }}>{checklist.name}</h3>

					<Button
						variant="light"
						className="float-right"
						style={{ marginTop: -5 }}
						onClick={handleDelete}
					>
						Delete
					</Button>
				</>
			}
			editComponent={
				<FormControl
					defaultValue={checklist.name ? checklist.name : ""}
					onChange={(event: ChangeEvent<HTMLInputElement>) => {
						checklist.name = event.target.value;
					}}
					className="mb-4"
				/>
			}
			onFinishedEditing={() => {
				projectContext.saveUpdateProjectTaskChecklist!(task, checklist);
			}}
		/>
	);

	const checklistItems = checklist.items.map(
		(item: ProjectTaskChecklistItem, index: number) => {
			return (
				<ProjectTaskChecklistItemElement
					key={index}
					item={item}
					checklist={checklist}
					task={task}
				/>
			);
		},
	);

	const completed = checklist.items.filter(item => item.completed === true);
	return (
		<div className="checklist-wrapper mt-4">
			{editableName}
			<ProgressBar
				now={(completed.length / checklist.items.length) * 100}
			/>
			{checklistItems}
			<Button variant="light" onClick={handleAddItem} className="mt-2">
				Add an item
			</Button>
		</div>
	);
};
